import { render, staticRenderFns } from "./Estudiocerrar.vue?vue&type=template&id=27534944&"
import script from "./Estudiocerrar.vue?vue&type=script&lang=js&"
export * from "./Estudiocerrar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports